export const riskyProspectWarningconstants = {
  INCLUDE_RISKY_PROSPECT_IN_SEQUENCE:
    'Emails will be sent to the risky prospects. You can modify this from sequence settings.',
  NOT_INCLUDE_RISKY_PROSPECT_IN_SEQUENCE:
    'Emails will not be sent to the risky prospects. You can modify this from sequence settings.',
  PROSPECT_DEFAULT_WARNING:
    'In order to send emails to the risky prospects, modify the sequence settings.',
};
